import * as React from 'react'
import { Button } from '../../atoms/button/button'
import CollegeService from '../../../services/college-service'
import { actualStage, concourseId } from '../../../constants/activity-constants'
import { Context } from '../../../context/app-context'
import { goToMenuOption } from '../../../utils/useMenuOptions'
import useMediaQuery from '../../../shared/utils/useMediaQuery'
import './ranking.scss'

export const Ranking = () => {
  const isMobile = useMediaQuery()
  const [userPosition, setUserPosition] = React.useState()
  const [userCollegePosition, setUserCollegePosition] = React.useState()
  const [usersRanking, setUsersRanking] = React.useState()
  const [collegeRanking, setCollegeRanking] = React.useState()
  const { userParticipation } = React.useContext(
    Context
    )

  const goToRegisterCollege = () => {
    goToMenuOption(isMobile ? 'register-college' : 'registrar-claves')
  }

  const getUserPosition = React.useCallback(
    () => {
      CollegeService.getUserPosition({
        concourseId
      }).then(res => {
        if (res.status === 200) {
          setUserPosition(res.data)
        }
      })
    },
    []
  )

  const getUserCollegePosition = React.useCallback(
    () => {
      CollegeService.getUserCollegePosition({
        concourseId
      }).then(res => {
        if (res.status === 200) {
          setUserCollegePosition(res.data)
        }
      })
    },
    []
  )

  const getUsersRanking = React.useCallback(
    () => {
      CollegeService.getUsersTop({
        concourseId,
        size: 7,
      }).then(res => {
        if (res.status === 200) {
          setUsersRanking(res.data)
        }
      })
    },
    []
  )

  const getCollegeRanking = React.useCallback(
    () => {
      CollegeService.getCollegesTop({
        concourseId,
        size: 7,
      }).then(res => {
        if (res.status === 200) {
          setCollegeRanking(res.data)
        }
      })
    }, [])

  React.useEffect(() => {
    getUsersRanking()
    getCollegeRanking()
  }, [getUsersRanking, getCollegeRanking, userParticipation])


  React.useEffect(() => {
    if (userParticipation) {
      getUserPosition()
      getUserCollegePosition()
    }
  }, [getUserCollegePosition, getUserPosition, userParticipation])

  return (
    <section className="f-ranking" id="ranking">
      <h2 className="f-ranking__title">RANKING</h2>
      <h2 className="f-ranking__title f-ranking__title--pink">
        {actualStage}
      </h2>
      <h3 className="f-ranking__secondary-title">
        ¡Guarda tus empaques! Los necesitarás para recibir tu premio en caso de
        ser ganadora.
      </h3>

      {userParticipation?.totalUserKey > 0 && userPosition && (
        <div className="f-ranking__user-score">
          <div className="f-ranking__user-score__participation">
            <b>{userPosition.position}.</b>
            <p title={userPosition?.name}> {userPosition?.name}</p>
            <b>{userPosition?.totalKey} claves</b>
          </div>

          {userCollegePosition?.totalKey > 0 && userCollegePosition?.name ? (
              process.env.LOCALE !== "es-EC" ?
            <div className="f-ranking__user-score__participation">
              <b>{userCollegePosition.position}.</b>
              <p title={userCollegePosition?.name}> {userCollegePosition?.name}</p>
              <b>{userCollegePosition?.totalKey} claves</b>
            </div>
            : ''
          ) : userCollegePosition?.totalKey == 0 ?
            <></>
            : (
            process.env.LOCALE !== "es-EC" ?
            <Button
              color="blue"
              type="button"
              action={goToRegisterCollege}
              text="REGISTRAR MI COLEGIO"
              className="f-ranking__user-score__button"
            />
            : ''
          )}
        </div>
      )}

      <div className="f-ranking__score">
        <div className="f-ranking__score__user">
          <p className="f-ranking__score__title">
            Las mejores <b>jugadoras</b> están aquí:
          </p>

          <ul className="f-ranking__score__user__list">
            <p className="f-ranking__score__user__list__no-result">
              TOP usuarias
            </p>

            {usersRanking?.topCompetitionKey?.map((winner, index) => {
              let nameSplited = winner.name.split(' ')
              let fullName = `${nameSplited[0]} ${nameSplited.length > 1 ? nameSplited[1] : ''
                }`

              return process.env.LOCALE !== "es-EC" ? (
                <li key={index}>
                  <p>
                    <p>{`${index + 1}. ${fullName}`}</p>
                    <small>{winner.detail}</small>
                  </p>
                </li>
              ):
              (
                <li key={index} className="f-li-ecuador">
                    <p className="f-p-ecuador">{`${index + 1}. ${fullName}`}</p>
                    <small className="f-small-ecuador">{winner.detail}</small>
                </li>
              )
            })}

            {(!usersRanking ||
              usersRanking?.topCompetitionKey?.length <= 0) && (
                <strong>No hay resultados</strong>
              )}
          </ul>
        </div>
        {
          process.env.LOCALE !== "es-EC" ?
          <div className="f-ranking__score__college">
          <p className="f-ranking__score__title">
            Los mejores <b>colegios</b> están aquí:
          </p>

          <div className="f-ranking__score__college__table">
            <div className="f-ranking__score__college__table__header">
              <p className="f-ranking__score__college__table__title">
                <b>Top Colegios</b>
              </p>
              <p className="f-ranking__score__college__table__title">Ciudad</p>
            </div>

            {collegeRanking?.topCompetitionKey?.map((college, index) => {
              return (
                <div
                  className="f-ranking__score__college__table__row"
                  key={index}
                >
                  <p className="f-ranking__score__college__table__row__name">
                    {`${index + 1}. ${college.name}`}
                    <small>{college.emailUser}</small>
                  </p>
                  <p className="f-ranking__score__college__table__row__city">
                    {college?.detail}
                  </p>
                </div>
              )
            })}

            {(!collegeRanking ||
              collegeRanking?.topCompetitionKey?.length <= 0) && (
                <p className="f-ranking__score__user__list__no-result">
                  No hay resultados
                </p>
              )}
          </div>
        </div>
        : ''
        }

      </div>
    </section>
  )
}
